import { Routes } from '@angular/router';
import { LoginComponent } from './features/account/login/login.component';
import { PageNotFoundComponent } from './features/page-not-found/page-not-found.component';
import { universalAuthGuard } from './shared/guard/auth.guard';
import { ExpenseMonitorApprovalComponent } from './features/monitor-expenses/expense-monitor-approval/expense-monitor-approval.component';
import { ResetPasswordComponent } from './features/account/reset-password/reset-password.component';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'password-reset',
    component: ResetPasswordComponent,
    title: 'Password reset',
    pathMatch: 'full',
  },
  {
    path: 'bms',
    canActivate: [universalAuthGuard],
    data: { label: 'bms', url: '/bms/dashboard' },
    loadChildren: () =>
      import('./features/bms/bms.routing').then((m) => m.routes),
  },
  { path: '**', component: PageNotFoundComponent, title: 'page not found' },
];
